import { render, staticRenderFns } from "./mailList.vue?vue&type=template&id=2afe043f&scoped=true&"
import script from "./mailList.vue?vue&type=script&lang=js&"
export * from "./mailList.vue?vue&type=script&lang=js&"
import style0 from "./mailList.vue?vue&type=style&index=0&id=2afe043f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe043f",
  null
  
)

export default component.exports